import React, { Component, Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import { Log, Level, Logger, Display } from 'ng2-logger';
import CourseContentSelectionMenu from '../../course-content-selection-vertical-menu/main';
import DocumentActivityCard from '../../activity-cards/document/main';
import { IActivityCard, IActivityCardItems } from '../../../../models/components/activity-card';
import { IAppState, IAction } from '../../../../models/action/core';
import { connect } from 'react-redux';
import { ActivityType } from '../../../../models/enums/ActivityType';
import Loading from '../../../loading/loading';
import SurveyActivityCard from '../../activity-cards/survey/main';
import * as Actions from '../../../../store/actions/coursePage';
import { CourseContentMenuType } from '../../../../models/enums/CourseContentMenuType';
import { GetActivitiesType } from '../../../../models/enums/GetActivityType';
import ActivityCardContainer from '../../activity-cards/main';
const _logger = Log.create('CourseContentContainer');

class CourseContentContainer extends React.Component<IActivityCard> {
    constructor(props: any) {
        super(props);
    }

    onClickTop = () => {
        const activitiesTab = document.getElementById('activities-tab');

        if (activitiesTab) {
            activitiesTab.scrollTop = 0;
        }
    }


    public render() {
        return (
            <div className="tab-content pt-0">
                <div className="tab-pane fade active show" id="courseContent" role="tabpanel" aria-labelledby="courseContent-tab">
                    <div className="content-container mobile-lesson-content" style={{ float: 'none', display: 'flex' }}>
                        <div className='mobile-none'>
                        <CourseContentSelectionMenu showMobile={window.innerWidth <= 768}  />
                        </div>
                        <div id="activities-tab" className="tabs-section mobil-full " style={{ backgroundColor: '#fbfaf6', scrollBehavior: 'smooth', overflowY: 'auto', overflowX: 'hidden', paddingTop: '0px !important', height: '82vh' }}>
                            <div className="container" style={{ maxWidth: '100%' }}>

                                {/* <Loading spinnerId={"getCourseContentMenu"} /> */}
                                <ActivityCardContainer />

                            </div>
                            <a id="go-top" className="animated fadeOut" onClick={this.onClickTop}>
                                <span className="material-icons">
                                    arrow_upward
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IActivityCard): IActivityCard => {
    if (!state) {
        return ownProps;
    }
    const newProps: IActivityCard = Object.assign({}, ownProps, {
        courseContentMenuLoading: state.coursePage.courseContentMenuLoading
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

/* const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.courseContentMenuLoading === prev.coursePage.courseContentMenuLoading
    );
    return ret;
}; */

const CCourseContentContainer = connect(
    mapStateToProps,
    dispatchProps,
    /*     null,
        {
            areStatesEqual
        } */
)(CourseContentContainer);

export default CCourseContentContainer;